import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { ValueProps } from "@/components/site/ValueProps";
import { Products } from "@/components/site/Products";
import { Catalog } from "@/components/site/Catalog";
import { ChairCollection } from "@/components/site/ChairCollection";
import { Manufacturing } from "@/components/site/Manufacturing";
import { Portfolio } from "@/components/site/Portfolio";
import { GalleryStrip } from "@/components/site/GalleryStrip";
import { Catalogs } from "@/components/site/Catalogs";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";
import AdminApp from "@/admin/AdminApp";

const Home = () => (
    <main className="bg-bone">
        <Nav />
        <Hero />
        <EditorialMarquee />
        <ValueProps />
        <Products />
        <Catalog />
        <ChairCollection />
        <Manufacturing />
        <Portfolio />
        <GalleryStrip />
        <Catalogs />
        <Contact />
        <Footer />
    </main>
);

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.15, anchors: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <BrowserRouter>
            <Toaster position="top-center" richColors />
            <Routes>
                <Route path="/admin" element={<AdminApp />} />
                <Route path="*" element={<Home />} />
            </Routes>
        </BrowserRouter>
    );
}

export default App;
